import { z } from 'zod';

export const AnalyzeImageSchema = z.object({
  imageUrl: z.string().min(1, 'Image URL cannot be empty'),
  language: z.string().optional().default('de'),
});

export type IAnalyzeImageDto = z.infer<typeof AnalyzeImageSchema>;
